import React from 'react';
import { Link } from 'react-router-dom';
import {
  Page,
  Hero,
  HeroContent,
  HeroTag,
  HeroHighlights,
  Section,
  SectionTitle,
  SectionText,
  SectionGrid,
  Card,
  List,
  Callout,
} from './InfoPageStyles';

const BusinessRegistry = () => (
  <Page>
    <Hero>
      <HeroContent>
        <HeroTag>Support</HeroTag>
        <h1>Business Registry</h1>
        <p>
          The Business Registry supports food premises registration, licensing, and compliance
          for restaurants, processors, importers, markets, and distributors. Registering keeps
          consumers safe and helps businesses operate with confidence.
        </p>
        <HeroHighlights>
          <li>Register new food premises and update ownership details.</li>
          <li>Access licensing requirements and inspection guidance.</li>
          <li>Track application status and renewal timelines.</li>
        </HeroHighlights>
      </HeroContent>
    </Hero>

    <Section>
      <SectionTitle>Registration steps</SectionTitle>
      <SectionText>
        Our registry team provides guidance for new applicants and renewals. Start early to
        ensure inspections and document review are completed on time.
      </SectionText>
      <List>
        <li>Submit premises information, business contacts, and location details.</li>
        <li>Prepare sanitation, storage, and workflow documentation.</li>
        <li>Schedule inspections and address any corrective actions.</li>
        <li>Receive licensing confirmation and maintain annual renewals.</li>
      </List>
    </Section>

    <Section>
      <SectionTitle>How the registry supports you</SectionTitle>
      <SectionGrid>
        <Card>
          <h3>New registrations</h3>
          <p>
            Guidance on documentation, application forms, and inspection readiness for newly
            established businesses.
          </p>
        </Card>
        <Card>
          <h3>Renewals</h3>
          <p>
            Timelines and reminders to keep licenses active and avoid disruptions to operations.
          </p>
        </Card>
        <Card>
          <h3>Compliance support</h3>
          <p>
            Ongoing advice on hygiene requirements, record keeping, and corrective actions.
          </p>
        </Card>
      </SectionGrid>
      <Callout>
        <strong>Ready to register?</strong>
        <span>Start a food premises application or log in to continue an existing one.</span>
        <div>
          <Link to="/food-premises">Start application</Link> |{' '}
          <Link to="/business/login">Food premises login</Link>
        </div>
      </Callout>
    </Section>
  </Page>
);

export default BusinessRegistry;
